import styles from "./checkout.module.css";
interface CheckoutConfirmationProps {}

export const CheckoutConfirmation = (props: CheckoutConfirmationProps) => {
  return <div>checkout confirmation</div>;
};
